export default __webpack_public_path__ + "static/media/Book-1.95ea1974.jpg";